export default __webpack_public_path__ + "static/media/3_Meritxell Bañon_179x177.c8b73cb9.webp";